import { createTheme } from '@mui/material/styles';
import {Colors} from '../Constants'


export const AdminPageTheme = createTheme({
    typography: {
        fontFamily: '"Noto Sans JP","游ゴシック Medium",YuGothic,YuGothicM,"Hiragino Kaku Gothic ProN",\
                     "Hiragino Kaku Gothic Pro",メイリオ,Meiryo,sans-serif',
    },
    palette: {
        primary: {
            main: Colors.AdminPrimary,
        },
        secondary: {
            main: Colors.Alert,
        },
        info: {
            main: Colors.SecondaryActive,
        }
    },
    components: {
        MuiTablePagination: {
            styleOverrides: {
                selectLabel: {
                    color: 'black',
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    whiteSpace: 'nowrap',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    padding: '0px 5px 0px 5px',
                    backgroundColor: 'white',
                },
                input: {
                    '&$disabled': {
                        backgroundColor: '#DDD',
                    },
                },
                multiline: {
                    padding: '0px 5px 0px 5px',
                    backgroundColor: 'white',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    backgroundColor: 'white',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '14px 12px 14px 12px',
                },
            },
        },
    },
})

// export const AdminPageTheme = createTheme(adaptV4Theme({
//     typography: {
//         fontFamily: '"Noto Sans JP","游ゴシック Medium",YuGothic,YuGothicM,"Hiragino Kaku Gothic ProN",\
//                      "Hiragino Kaku Gothic Pro",メイリオ,Meiryo,sans-serif',
//     },
//     palette: {
//         primary: {
//             main: Colors.AdminPrimary,
//         }
//     },
//     overrides: {
//         MuiTablePagination: {
//             caption: {
//                 color: 'black',
//             },
//         },
//         MuiInputAdornment: {
//             root: {
//                 whiteSpace: 'nowrap',
//             },
//         },
//         MuiInputBase: {
//             root: {
//                 padding: '0px 5px 0px 5px',
//                 backgroundColor: 'white',
//             },
//             input: {
//                 '&$disabled': {
//                     backgroundColor: '#DDD',
//                 },
//             },
//             multiline: {
//                 padding: '0px 5px 0px 5px',
//                 backgroundColor: 'white',
//             },
//         },
//         MuiSelect: {
//             root: {
//                 backgroundColor: 'white',
//             },
//         },
//         MuiTableCell: {
//             root: {
//                 padding: '14px 12px 14px 12px',
//             },
//         },
//     },
// }))
